<div style="text-align: left;margin-top: 1.1rem; margin-bottom: 3rem;">
    <span>{{this.privacyagreementGDPR1}}</span>&nbsp;<span translate><a target="_blank" href="{{viewPdf()}} " translate>COMMONS.PRIVACY_POLICY</a></span>
    <br/>
    <span>{{this.privacyagreementGDPR2}}</span>
</div>
<mat-card>
    <div class="col-12" style=" display: flex; flex-direction: row; justify-content: space-between;padding: 0;text-align: left; ">
        <div style="padding: 2rem;">
            <mat-slide-toggle [checked]="this.privacyAgreementService.PersonalDataAgreeInt" [disabled]='this.privacyAgreementService.DisablePersonalDataAgreeExt' [disableRipple]="true" (change)="onValueChangePersonalDataAgreeInt($event)" #chkboxPersonalDataAgreeInt></mat-slide-toggle>

        </div>
        <div style="padding: 2rem;">
            <span class="textLarge">{{this.privacyagreementVsZucchetti}}</span>
            <div class="textLarge text-italic">(<span translate>COMMONS.MANDATORY_CHOICE</span>)</div>

        </div>

    </div>
    <!--box2-->
    <div class="col-12" style="display: flex; flex-direction: row; justify-content: flex-end;padding: 0;text-align: left;">
        <div style="padding: 2rem;">
            <mat-slide-toggle [checked]="this.privacyAgreementService.PersonalDataAgreeExt" [disableRipple]="true" (change)="onValueChangePersonalDataAgreeExt($event)" #chkboxPersonalDataAgreeExt>
            </mat-slide-toggle>
        </div>
        <div style="padding: 2rem;">
            <span class="textLarge">{{this.privacyagreementvsThird}}</span>
            <div class="textLarge text-italic">(<span translate>COMMONS.OPTIONAL_CHOICE</span>)</div>
        </div>

    </div>
</mat-card>